function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#E03616;}\n\t.st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 421,
  height: 97.7
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix( 1, 0, 0, 1, 0,0) "
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M381.7,31.8c0.8-0.8,1.2-1.7,1.2-2.9c0-1.1-0.4-2.1-1.2-2.9c-0.8-0.8-1.7-1.2-2.9-1.2 c-1.1,0-2.1,0.4-2.9,1.2l-16,16l-16-16c-0.8-0.8-1.7-1.2-2.9-1.2c-1.1,0-2.1,0.4-2.9,1.2c-0.8,0.8-1.2,1.8-1.2,2.9 c0,1.1,0.4,2.1,1.2,2.9l16,16l-16,16c-0.8,0.8-1.2,1.8-1.2,2.9c0,1.1,0.4,2.1,1.2,2.9c0.8,0.8,1.8,1.2,2.9,1.2 c1.1,0,2.1-0.4,2.9-1.2l16-16l16,16c0.8,0.8,1.8,1.2,2.9,1.2c1.1,0,2.1-0.4,2.9-1.2c0.8-0.8,1.2-1.7,1.2-2.9 c0-1.1-0.4-2.1-1.2-2.9l-16-16L381.7,31.8z"
}))))));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M26.2,71.8V22.4h10.9v49.4H26.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M44.5,71.8V22.4h7.7l10.1,23.8V22.4h9v49.4H64L53.8,46.2v25.6H44.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M92.9,72.5c-3.7,0-6.7-0.7-8.9-2c-2.2-1.4-3.7-3.3-4.6-5.7c-0.9-2.5-1.3-5.4-1.3-8.7V38.3 c0-3.4,0.4-6.4,1.3-8.8c0.9-2.5,2.4-4.4,4.6-5.7c2.2-1.3,5.1-2,8.9-2c3.7,0,6.5,0.6,8.6,1.8c2.1,1.2,3.5,2.9,4.4,5 c0.9,2.2,1.3,4.6,1.3,7.4v4.3H96.4v-4.9c0-1-0.1-1.9-0.2-2.8s-0.4-1.6-0.9-2.2c-0.5-0.6-1.3-0.9-2.5-0.9c-1.1,0-2,0.3-2.5,0.9 c-0.5,0.6-0.9,1.4-1,2.3s-0.2,1.9-0.2,2.9v23.2c0,1.1,0.1,2.1,0.3,3c0.2,0.9,0.5,1.6,1.1,2.2s1.4,0.8,2.4,0.8c1.1,0,2-0.3,2.4-0.9 s0.8-1.4,0.9-2.3c0.1-0.9,0.2-1.9,0.2-2.9v-5.2h10.7v4.3c0,2.8-0.4,5.3-1.3,7.5c-0.8,2.2-2.3,4-4.3,5.2 C99.5,71.9,96.6,72.5,92.9,72.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M127.2,72.5c-3.7,0-6.6-0.7-8.8-2c-2.2-1.3-3.7-3.2-4.6-5.6c-0.9-2.4-1.4-5.3-1.4-8.7V37.9 c0-3.4,0.5-6.3,1.4-8.7c0.9-2.4,2.5-4.2,4.6-5.5c2.2-1.3,5.1-1.9,8.8-1.9c3.7,0,6.7,0.6,8.9,1.9c2.2,1.3,3.7,3.1,4.7,5.5 c0.9,2.4,1.4,5.3,1.4,8.7v18.4c0,3.4-0.5,6.3-1.4,8.7c-0.9,2.4-2.5,4.3-4.7,5.6C133.9,71.9,131,72.5,127.2,72.5z M127.2,64.8 c1.1,0,2-0.3,2.5-0.9c0.5-0.6,0.9-1.3,1-2.2c0.2-0.9,0.2-1.8,0.2-2.7V35.2c0-1-0.1-1.9-0.2-2.8c-0.2-0.9-0.5-1.6-1-2.2 c-0.5-0.6-1.4-0.9-2.5-0.9c-1.1,0-1.9,0.3-2.4,0.9s-0.9,1.3-1,2.2c-0.2,0.9-0.2,1.8-0.2,2.8V59c0,0.9,0.1,1.9,0.2,2.7 c0.1,0.9,0.5,1.6,1,2.2C125.3,64.5,126.1,64.8,127.2,64.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M148.8,71.8V22.4h13.6c3.3,0,6.2,0.4,8.7,1.1c2.4,0.7,4.3,2,5.7,3.9c1.4,1.9,2,4.6,2,8c0,2-0.2,3.8-0.5,5.4 c-0.3,1.6-0.9,3-1.8,4.1c-0.9,1.2-2.1,2.1-3.8,2.9l6.8,23.9h-11.3l-5.4-22.1h-3.1v22.1H148.8z M159.7,43.4h3c1.5,0,2.7-0.3,3.6-0.8 c0.9-0.5,1.5-1.3,1.8-2.4c0.3-1,0.5-2.3,0.5-3.8c0-2.1-0.4-3.8-1.2-4.9c-0.8-1.2-2.2-1.8-4.3-1.8h-3.5V43.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M185.2,71.8V22.4h13.6c3.3,0,6.2,0.4,8.7,1.1c2.4,0.7,4.3,2,5.7,3.9c1.4,1.9,2,4.6,2,8c0,2-0.2,3.8-0.5,5.4 c-0.3,1.6-0.9,3-1.8,4.1c-0.9,1.2-2.1,2.1-3.8,2.9l6.8,23.9h-11.3l-5.4-22.1h-3.1v22.1H185.2z M196.1,43.4h3c1.5,0,2.7-0.3,3.6-0.8 c0.9-0.5,1.5-1.3,1.8-2.4c0.3-1,0.5-2.3,0.5-3.8c0-2.1-0.4-3.8-1.2-4.9c-0.8-1.2-2.2-1.8-4.3-1.8h-3.5V43.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M221.5,71.8V22.4h22.2v7.4h-11.3v12.3h8.6v7.6h-8.6v14.8h11.4v7.4H221.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M262.9,72.5c-3.7,0-6.7-0.7-8.9-2c-2.2-1.4-3.7-3.3-4.6-5.7c-0.9-2.5-1.3-5.4-1.3-8.7V38.3 c0-3.4,0.4-6.4,1.3-8.8c0.9-2.5,2.4-4.4,4.6-5.7c2.2-1.3,5.1-2,8.9-2c3.7,0,6.5,0.6,8.6,1.8c2.1,1.2,3.5,2.9,4.4,5 c0.9,2.2,1.3,4.6,1.3,7.4v4.3h-10.7v-4.9c0-1-0.1-1.9-0.2-2.8s-0.4-1.6-0.9-2.2c-0.5-0.6-1.3-0.9-2.5-0.9c-1.1,0-2,0.3-2.5,0.9 c-0.5,0.6-0.9,1.4-1,2.3s-0.2,1.9-0.2,2.9v23.2c0,1.1,0.1,2.1,0.3,3c0.2,0.9,0.5,1.6,1.1,2.2s1.4,0.8,2.4,0.8c1.1,0,2-0.3,2.4-0.9 s0.8-1.4,0.9-2.3c0.1-0.9,0.2-1.9,0.2-2.9v-5.2h10.7v4.3c0,2.8-0.4,5.3-1.3,7.5c-0.8,2.2-2.3,4-4.3,5.2 C269.5,71.9,266.6,72.5,262.9,72.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M287.6,71.8V30.5h-7.4v-8.1h25.8v8.1h-7.4v41.3H287.6z"
}));

function SvgIncorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 421 97.7",
    style: {
      enableBackground: "new 0 0 421 97.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/Incorrect.c9da6b965660e3f66991f23d8f833707.svg";
export { ForwardRef as ReactComponent };